import React, { Component } from 'react';

import Dialog, {
    DialogActions,
    DialogContent,
    DialogTitle
} from 'material-ui/Dialog';

import PrimaryButton from '../common/component/PrimaryButton';
import SecondaryButton from '../common/component/SecondaryButton';
import Console from '../../lib/debug';

class DialogFactory extends Component {
    onKeyDown = event => {
        if (this.props.saveOnEnter && event.key === 'Enter') {
            return this.props.handleSave();
        }
    };

    saveButton = () => {
        return this.props.handleSave ? (
            <PrimaryButton onClick={this.props.handleSave}>
                {this.props.saveButtonTitle || 'Save'}
            </PrimaryButton>
        ) : null;
    };

    render = () => {
        Console.render('DialogFactory');

        return (
            <Dialog
                open={this.props.enabled}
                onClose={this.props.handleClose}
                aria-labelledby="delete-dialog"
                className="th-dialog"
                onKeyDown={event => this.onKeyDown(event)}
            >
                <DialogTitle className="th-dialog-title">
                    {this.props.header || ''}
                </DialogTitle>
                <DialogContent className="th-dialog-content">
                    {this.props.text || ''}
                </DialogContent>
                <DialogActions className="th-dialog-actions">
                    <SecondaryButton onClick={this.props.handleClose}>
                        {this.props.cancelButtonTitle || 'Cancel'}
                    </SecondaryButton>
                    {this.saveButton()}
                </DialogActions>
            </Dialog>
        );
    };
}

export default DialogFactory;
